import React from 'react'
import CartItem from '../components/CartItems/CartItem'

const cart = () => {
  return (
    <div>
      <CartItem/>
      </div>
  )
}

export default cart